import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Button } from '@/components/button'
import { TdActions } from '@/components/tdActions'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'

const deleteTokenColumnProps = ({ deleteToken, localize }) => {
  class ActionButtonsCell extends GridCell {
    render () {
      const { id } = this.props.dataItem
      return (
        <TdActions>
          <Button
            iconOnly
            confirmTitle='Common.Confirmation'
            confirmText='Common.AreYouSure'
            onClick={() => openTwoFactorDialog(() => deleteToken({ id }))}
            icon='x' />
        </TdActions>
      )
    }
  }
  return {
    sortable: false,
    filterable: false,
    cell: ActionButtonsCell
  }
}

export {
  deleteTokenColumnProps
}



// WEBPACK FOOTER //
// ./src/components/userProfile/personalAccessTokens/gridActions.js